import * as styles from "./Heading1.scss";
import { SimpleComponent } from "./SimpleComponent";

export class Heading1 extends SimpleComponent {
    protected className = styles.heading1;
    protected tag = "h1";
}
